import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { cancelTokenSelector } from '../redux/selectors/selectors';
import { setAlarm } from '../redux/actions/general';
import { ANALYTICS_API_URL } from '../constants/config';
import * as browserStorage from '../misc/BrowserStorageManager';
import { getUnifiedErrorObject } from '../util/ErrorUnifier';
import { useMutation } from '@tanstack/react-query';

function useTokenRevocation({ token }) {
   const jwtToken = browserStorage.getJwtToken();

   const dispatch = useDispatch();
   const cancelToken = useSelector(cancelTokenSelector);

   const analyticsHttpHeader = useMemo(() => ({ 'x-access-token': jwtToken, 'Content-Type': 'application/json' }), [
      jwtToken,
   ]);

   const { mutate, isLoading, isSuccess, error: mutationError, reset } = useMutation(
      async () => {
         return axios({
            method: 'POST',
            url: `${ANALYTICS_API_URL}/v2/playback/token/revoke`,
            data: { token },
            headers: analyticsHttpHeader,
            cancelToken: cancelToken.token,
         }).then((res) => res.data);
      },
      {
         onError: (err) => {
            if (!(err instanceof axios.Cancel)) {
               const errorObj = getUnifiedErrorObject(err);
               dispatch(setAlarm('danger', errorObj));
            }
         },
      },
   );

   return {
      revoke: mutate,
      isLoading,
      isSuccess,
      error: mutationError ? getUnifiedErrorObject(mutationError) : undefined,
      reset,
   };
}

export default useTokenRevocation;
